import { render, staticRenderFns } from "./BrandFlowOverview.vue?vue&type=template&id=6b552600&scoped=true"
import script from "./BrandFlowOverview.vue?vue&type=script&lang=js"
export * from "./BrandFlowOverview.vue?vue&type=script&lang=js"
import style0 from "./BrandFlowOverview.vue?vue&type=style&index=0&id=6b552600&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b552600",
  null
  
)

export default component.exports